import React from "react";
import { withAppState } from "../../state";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { Text, withFocusable } from "../../services/visualLibraryService";
import {
  LandingPageStyled,
  LandingContainerStyled,
  HeadingStyled,
  ButtonModalStyled,
  LogoStyled,
  SecondaryLogoStyled,
  TextStyled
} from "./styles/Styled";
import { i18n } from "../../services/i18nService";
import { isUserAccountActive } from "../../services/accountStatusService";
import { getVoucherDurationText } from "../../services/copyService";
import { getAppState } from "../../state/index";
import { trackPage, trackEvent } from "../../services/analyticsService";
import { historyMethods } from "../../utils/historyMethods";
import { redirectTo } from "../../services/navigationService";
import { routes } from "../../routes";

const PAGE = "landing";
const SIGNUP = "signup";
const ButtonModalFocus = withFocusable(ButtonModalStyled);
const joinFocusPath = "joinVoucherModal_passThru";
const loginFocusPath = "loginVoucherModal_passThru";
const browseFocusPath = "browseVoucherModal_passThru";
const startFocusPath = "startVoucherModal_passThru";
const closeFocusPath = "closeVoucherModal_passThru";

class LandingPage extends React.Component {
  constructor(props) {
    super(props);
    this.onBack = this.onBack.bind(this);
    this.enterHandler = this.enterHandler.bind(this);
    this.getActiveUserCloseHandler = this.getActiveUserCloseHandler.bind(this);
  }

  componentDidMount() {
    const {
      applicationState: { userLogged },
      onRef
    } = this.props;
    trackPage(PAGE);
    onRef && onRef(this);
    this.props.setFocus(`${userLogged ? startFocusPath : joinFocusPath}`);
  }

  getActiveUserCloseHandler() {
    const {
      applicationState: { userAccountStatus }
    } = this.props;
    isUserAccountActive(userAccountStatus) && localStorage && localStorage.setItem("showVoucherPopup", false);
    this.enterHandler("landing_user_selects_later", routes.home);
  }

  enterHandler(eventAction, path, locationData) {
    trackEvent(SIGNUP, eventAction);
    redirectTo.call(this, path, locationData, historyMethods.REPLACE);
  }

  onBack() {
    redirectTo.call(this, routes.home, null, historyMethods.REPLACE);
    return true;
  }

  render() {
    const { userLogged, userAccountStatus, voucherData } = getAppState();
    const voucherDuration = !!voucherData && getVoucherDurationText(voucherData.duration.duration);
    return (
      <LandingPageStyled
        background={`http://mena-img-cdn-lb.aws.playco.com/prd-peg-data/default/bigscreen/images/tizen/samsung-evoucher/samsungEvoucherCover_${i18n.getDirection()}.jpg`}
      >
        <LandingContainerStyled>
          <LogoStyled />
          <SecondaryLogoStyled src="../../images/tizen/samsung-evoucher/samsung.svg" alt="SAMSUNG" />
          <SecondaryLogoStyled src="../../images/tizen/samsung-evoucher/smartpack.svg" alt="SmartPack" />
          <HeadingStyled rank="1" text={i18n.get("pages.landing.eVoucher.title")} size="medium" />

          <TextStyled text={i18n.get("pages.landing.eVoucher.text")} size="small" />
          <TextStyled text={i18n.get("pages.landing.eVoucher.instructions.paragraph1")} size="small" />
          <TextStyled text={i18n.get("pages.landing.eVoucher.instructions.paragraph2")} size="small" />
          <TextStyled text={i18n.get("pages.landing.eVoucher.instructions.paragraph3")} size="small" />

          {!userLogged ? (
            <>
              <ButtonModalFocus
                label={i18n.get("global.eVoucher.join", voucherDuration)}
                focusPath={joinFocusPath}
                onEnterPress={() => this.enterHandler("landing_user_selects_joinnow", routes.signup)}
                size="small"
                dataSnUp={""}
                dataSnDown={`@${loginFocusPath}`}
                dataSnLeft={""}
                dataSnRight={""}
              />
              <ButtonModalFocus
                label={i18n.get("global.sections.login")}
                focusPath={loginFocusPath}
                onEnterPress={() =>
                  this.enterHandler("landing_user_selects_login", routes.pin, {
                    backDestination: routes.home,
                    nextPage: routes.redeem
                  })
                }
                size="small"
                dataSnUp={`@${joinFocusPath}`}
                dataSnDown={`@${browseFocusPath}`}
                dataSnLeft={""}
                dataSnRight={""}
              />
              <ButtonModalFocus
                label={i18n.get("global.explore")}
                focusPath={browseFocusPath}
                onEnterPress={() => this.enterHandler("landing_user_selects_explore", routes.home)}
                size="small"
                dataSnUp={`@${loginFocusPath}`}
                dataSnDown={""}
                dataSnLeft={""}
                dataSnRight={""}
              />
            </>
          ) : (
            <>
              <ButtonModalFocus
                label={i18n.get("global.eVoucher.start", voucherDuration)}
                focusPath={startFocusPath}
                onEnterPress={() => this.enterHandler("landing_user_selects_startnow", routes.redeem)}
                size="small"
                dataSnUp={""}
                dataSnDown={`@${closeFocusPath}`}
                dataSnLeft={""}
                dataSnRight={""}
              />
              <ButtonModalFocus
                label={isUserAccountActive(userAccountStatus) ? i18n.get("global.dontShow") : i18n.get("global.later")}
                focusPath={closeFocusPath}
                onEnterPress={this.getActiveUserCloseHandler}
                size="small"
                dataSnUp={`@${startFocusPath}`}
                dataSnDown={""}
                dataSnLeft={""}
                dataSnRight={""}
              />
            </>
          )}

          <Text text={i18n.get("global.eVoucher.disclaimer")} size="xsmall" />
        </LandingContainerStyled>
      </LandingPageStyled>
    );
  }
}

export default withAppState(withSubtheme(LandingPage));
